import { useEffect } from 'react';
import { usePlayback } from '../../state/playback.ts';

export interface PlayheadProps {
  pxPerFrame: number;
  offset: number;
  scrollRef: React.RefObject<HTMLDivElement | null>;
  headerWidth: number;
}

/** The playhead line; follows playback by paging the timeline when it leaves the view. */
export function Playhead({ pxPerFrame, offset, scrollRef, headerWidth }: PlayheadProps) {
  const frame = usePlayback((s) => s.frame);
  const playing = usePlayback((s) => s.playing);
  const x = frame * pxPerFrame;

  useEffect(() => {
    const el = scrollRef.current;
    if (!el || !playing) return;
    const visible = el.clientWidth - headerWidth;
    if (x < el.scrollLeft || x > el.scrollLeft + visible - 20) el.scrollLeft = Math.max(0, x - visible * 0.1);
  }, [x, playing, scrollRef, headerWidth]);

  return <div className="playhead" style={{ transform: `translateX(${offset + x}px)` }} />;
}
